import { render, staticRenderFns } from "./VxInput.vue?vue&type=template&id=00d7faaa&scoped=true&lang=html"
import script from "./VxInput.vue?vue&type=script&lang=js"
export * from "./VxInput.vue?vue&type=script&lang=js"
import style0 from "./VxInput.vue?vue&type=style&index=0&id=00d7faaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d7faaa",
  null
  
)

export default component.exports